<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_hn.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_hn.png'
import list_img1 from '../../images/download/down-hn1.jpg'
import list_img2 from '../../images/download/down-hn2.jpg'
import list_img3 from '../../images/download/down-hn3.jpg'
import cut_img1 from '../../images/download/hnjt1.jpg'
import cut_img2 from '../../images/download/hnjt2.jpg'
import cut_img3 from '../../images/download/hnjt3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'琼崖海南麻将',
                size:'56.43',
                load_count:'2055',
                desp:'琼崖海南麻将是一款休闲类棋牌游戏，画面简约时尚，操作简单易懂。真人实时对战玩法，有箭牌、风牌，可吃牌、碰牌、杠牌，经典的“有番才能胡”，让您玩到嗨玩到爽，陪伴您快乐每一天。',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=hainan',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=hainan',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
